import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, CardContent, Container, Stack, Typography } from '@mui/material';
import { api, resolveAssetUrl } from '../../api';
import { fileToBase64 } from '../../utils/files';
import { useT } from '../../localization/LocalizationProvider';

const assetLabelKeys = {
  logo: 'Admin.GlobalSettings.Logo',
  correctSound: 'Admin.GlobalSettings.CorrectSound',
  wrongSound: 'Admin.GlobalSettings.WrongSound',
  roundCompleteSound: 'Admin.GlobalSettings.RoundCompleteSound'
};

export function GlobalSettingsPage() {
  const t = useT();
  const [settings, setSettings] = useState(null);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const load = async () => setSettings(await api.getGlobalSettings());
  useEffect(() => { load(); }, []);

  const uploadAsset = async (slot, file) => {
    try {
      const payload = await fileToBase64(file);
      const next = await api.uploadGlobalAsset(slot, payload);
      setSettings(next);
      setMessage(t('Admin.GlobalSettings.FileUploaded'));
      setError('');
    } catch (err) {
      setError(err.message);
      setMessage('');
    }
  };

  const deleteAsset = async (slot) => {
    const next = await api.deleteGlobalAsset(slot);
    setSettings(next);
    setMessage(t('Admin.GlobalSettings.FileDeleted'));
    setError('');
  };

  if (!settings) return null;

  return (
    <Container>
      <Stack spacing={3}>
        <Typography variant="h4">{t('Admin.GlobalSettings.Title')}</Typography>
        {message && <Alert severity="success">{message}</Alert>}
        {error && <Alert severity="error">{error}</Alert>}
        {Object.entries(assetLabelKeys).map(([slot, labelKey]) => {
          const asset = settings.assets?.[slot] || null;
          return (
            <Card key={slot}>
              <CardContent>
                <Stack spacing={2}>
                  <Typography variant="h6">{t(labelKey)}</Typography>
                  <Typography color="text.secondary">{asset ? t('Admin.GlobalSettings.FileAdded', { fileName: asset.fileName }) : t('Admin.GlobalSettings.FileMissing')}</Typography>
                  {asset?.url && slot === 'logo' && <img src={resolveAssetUrl(asset.url)} alt={t('Admin.GlobalSettings.LogoAlt')} style={{ maxWidth: 240, maxHeight: 120, objectFit: 'contain' }} />}
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Button variant="contained" component="label">
                      {t('Buttons.Upload')}
                      <input hidden type="file" accept={slot === 'logo' ? 'image/*' : 'audio/mpeg'} onChange={(event) => {
                        const file = event.target.files?.[0];
                        if (file) uploadAsset(slot, file);
                      }} />
                    </Button>
                    <Button color="error" disabled={!asset} onClick={() => deleteAsset(slot)}>{t('Common.Delete')}</Button>
                  </Stack>
                </Stack>
              </CardContent>
            </Card>
          );
        })}
      </Stack>
    </Container>
  );
}
